/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ILobasProductSelectorViewProps } from './lobas-product-selector';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import { ILobasProductSelectorData } from './lobas-product-selector.data';
import { ILobasProductSelectorProps } from './lobas-product-selector.props.autogenerated';

export const LobasProductSelectorFunctionalComponent: React.FC<ILobasProductSelectorViewProps &
    ILobasProductSelectorProps<ILobasProductSelectorData>> = (props: ILobasProductSelectorViewProps) => {
    return (
        <Module {...props.productSelector}>
            <Node className={'lobas-product-selector-dropdown'}>{props.selectorContainer}</Node>
        </Module>
    );
};

export default LobasProductSelectorFunctionalComponent;
